import getShouldShowOfficeTheme from 'owa-theme/lib/selectors/getShouldShowOfficeTheme';
import { isUserPersonalizationAllowed } from './isUserPersonalizationAllowed';
import { getNonBootUserConfigurationSync } from 'owa-nonboot-userconfiguration-manager';
import { ThemeConstants } from 'owa-theme-shared';

interface ThemeIdsAndCondition {
    themes: string[];
    isAvailable: () => boolean;
}

// These are in sorted order, which is why some conditionals may be repeated
export const themeIdsAndConditions: ThemeIdsAndCondition[] = [
    {
        themes: [ThemeConstants.BASE_THEME_ID],
        isAvailable: () => true,
    },
    {
        themes: [ThemeConstants.BASE_OFFICE_THEME_ID],
        isAvailable: () => getShouldShowOfficeTheme() && isUserPersonalizationAllowed(),
    },
    {
        themes: [ThemeConstants.CONTRAST_THEME_ID],
        isAvailable: () => true,
    },
    {
        // Pride themes
        themes: ['rainbow', 'ribbon', 'unicorn'],
        isAvailable: isUserPersonalizationAllowed,
    },
    {
        // EDU themes
        themes: ['supplies', 'backpack'],
        isAvailable: () => {
            const { IsEdu = false } = getNonBootUserConfigurationSync() || {};

            return IsEdu && isUserPersonalizationAllowed();
        },
    },
    {
        themes: [
            'mountain',
            'beach',
            'circuit',
            'blueprint',
            'far',
            'whale',
            'super',
            'jelly',
            'wrld',
            'angular',
            'balloons',
            'black',
            'blueberry',
            'bricks',
            'cats',
            'chevron',
            'comic',
            'cordovan',
            'crayon',
            'cubes',
            'cubism',
            'darkcordovan',
            'darkorange',
            'diamonds',
            'grape',
            'lightblue',
            'lightgreen',
            'lite',
            'mediumdarkblue',
            'minimal',
            'modern',
            'orange',
            'paint',
            'pink',
            'pixel',
            'polka',
            'pomegranate',
            'primary',
            'raspberry',
            'robot',
            'simple',
            'spectrum',
            'strawberry',
            'teagarden',
            'teal',
            'watermelon',
            'whimsical',
            'wntrlnd',
        ],
        isAvailable: isUserPersonalizationAllowed,
    },
];

export default function getAllThemeIds() {
    return themeIdsAndConditions.reduce(
        (accumulatedThemeIds: string[], currentSet) =>
            accumulatedThemeIds.concat(currentSet.isAvailable() ? currentSet.themes : []),
        []
    );
}
